import React, { useEffect, useState } from "react";
import Header from "pages/Header";
import { Box, Typography, ButtonGroup, Button } from "@mui/material";

import { useUserData } from "components/customHooks/userDataContext";
import { getRecentDictationSummary } from "apiHandler/actions";
import PracticeListTable from "components/UI/practiceListTable";
import PracticeChart from "components/UI/practiceChart";

const PracticeList = () => {
  const userData = useUserData();
  const [summary, setSummary] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dateRange, setDateRange] = useState("last_6_months");
  const [selectedPractices, setSelectedPractices] = useState([]);

  useEffect(() => {
    getSummary();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateRange]);

  const getSummary = async () => {
    try {
      setLoading(true);
      const payload = {
        user_id: userData?.email,
        data_range: dateRange,
      };
      const res = await getRecentDictationSummary(
        payload,
        userData?.access_token
      );
      const data = res || [];
      setSummary(data);

      const allPractices = Array.from(
        new Set(data.map((d) => d.practice_name))
      );
      setSelectedPractices(allPractices);
    } catch (error) {
      console.log("error: ", error);
      setSummary([]);
      setSelectedPractices([]);
    } finally {
      setLoading(false);
    }
  };

  const handlePracticeToggle = (name) => {
    setSelectedPractices((prev) =>
      prev.includes(name) ? prev.filter((p) => p !== name) : [...prev, name]
    );
  };

  return (
    <Box>
      <Box p={2}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <Typography fontSize={16} fontWeight={500}>
            Practice List
          </Typography>

          <ButtonGroup size="small" variant="outlined">
            <Button
              onClick={() => setDateRange("last_7_days")}
              variant={dateRange === "last_7_days" ? "contained" : "outlined"}
            >
              Last 7 Days
            </Button>
            <Button
              onClick={() => setDateRange("last_6_months")}
              variant={dateRange === "last_6_months" ? "contained" : "outlined"}
            >
              Last 6 Months
            </Button>
          </ButtonGroup>
        </Box>

        <PracticeChart
          summary={summary}
          selectedPractices={selectedPractices}
          onTogglePractice={handlePracticeToggle}
        />

        <PracticeListTable summary={summary} loading={loading} />
      </Box>
    </Box>
  );
};

export default PracticeList;
